<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-tabs
          style="border-top-right-radius: 0.5rem; border-top-left-radius: 0.5rem"
          grow
          background-color="primary"
          active-class="subtitle-1 font-weight-bold"
          center-active
      >
        <v-tab>
          Enquete em exibição
          <span class="tab-count" :class="{ 'tab-count--hidden': !filteredEnquete }">
            {{ filteredEnquete ? '1' : '0' }}
          </span>
        </v-tab>
      </v-tabs>

      <v-container class="colab-toolbar-container" fluid v-if="cod_producao">
        <div class="colab-toolbar">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            solo flat dense hide-details
            placeholder=""
            background-color="surface_tertiary"
            v-model="filtro_texto"
            @input="onChange"
            aria-label="Buscar"
            class="colab-search"
          />
        </div>

        <div
            @dragover.prevent="handleDragOver"
            @dragenter.prevent="handleDragOver"
            @dragleave="handleDragLeave"
            @drop="handleDrop($event)"
            class="drop-zone"
            :class="{ 'drop-zone--active': isDragOver }"
        >
          <template v-if="filteredEnquete">
            <div
                :key="filteredEnquete.id"
                class="card-item-wrapper"
                :class="{ 'drop-enter': lastDroppedId === filteredEnquete.id }"
            >
              <CardEnqueteEmExibicao
                  :item="filteredEnquete"
                  :get-enquetes-producao="getEnquetesProducao"
                  :get-enquete-em-exibicao="getEnqueteEmExibicao"
                  :page-aprovada="aprovadas_current_page"
                  :id_enquete_tarja="producao.id_enquete_tarja"
                  @reload-enquetes="reloadAllEnquetes"
              />
            </div>
          </template>
        </div>
      </v-container>
    </v-card-title>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { apiClient } from "@/services/api";
import { capitalizeString } from "@/utils/capitalizeString";
import CardEnqueteEmExibicao from "../Cards/Enquetes/CardEnqueteEmExibicao.vue";
import { dropTargetMixin } from "@/mixins/dragAndDrop";

export default {
  mixins: [dropTargetMixin],
  components: { CardEnqueteEmExibicao },
  data() {
    return {
      isModalImagemAprovadasVisible: false,
      media_type: null,
      midia_url_aprovadas: null,
      loading: false,
      filtro_texto: "",
    };
  },
  props: {
    enqueteEmExibicao: Object,
    aprovadas_current_page: Number,
    cod_producao: Number,
  },
  beforeMount() {
    this.filtro_texto =
      localStorage.getItem("@socialcam/filtro_texto_enquete_exibicao") || "";
  },
  computed: {
    ...mapGetters({
      tarjaParams: "tarja_enquete/getTarjaParams",
      configTarja: "tarja_enquete/getConfigTarja",
      producao: "producoes/getterProducao",
    }),
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    // Only one enquete is ever em exibição, so the search filters that single
    // item client-side (there is no server-side moderated list to refetch).
    filteredEnquete() {
      const enquete = this.enqueteEmExibicao;
      if (!enquete || !Object.keys(enquete).length) return null;
      const query = (this.filtro_texto || "").trim().toLowerCase();
      if (!query) return enquete;
      const haystack = `${enquete.dsc_titulo_enquete || ""} ${enquete.dsc_descricao_enquete || ""}`.toLowerCase();
      return haystack.includes(query) ? enquete : null;
    },
  },
  filters: {
    formatedDate(date) {
      return new Date(date).toLocaleDateString();
    },
    formatedHour(date) {
      return new Date(date).toLocaleTimeString().split(":").slice(0, 2).join(":");
    },
  },
  created() {
    this.getConfigTarja({
      cod_producao: this.$store.state.producoes.selectedProducao?.cod_producao,
    });
  },
  methods: {
    ...mapActions({
      getEnquetesProducao: "enquetes/getEnquetesProducao",
      getEnqueteEmExibicao: "enquetes/getEnqueteEmExibicao",
      getConfigTarja: "tarja_enquete/getConfigTarjaEnquete",
    }),
    async showModalImagem(midia_url_aprovadas, media_type) {
      this.isModalImagemAprovadasVisible = true;
      this.midia_url_aprovadas = midia_url_aprovadas;
      this.media_type = media_type;
    },
    async closeModalImagem() {
      this.isModalImagemAprovadasVisible = false;
    },
    capitalize(string) {
      return capitalizeString(string);
    },
    onChange(value) {
      localStorage.setItem("@socialcam/filtro_texto_enquete_exibicao", value);
    },
    async onDropAction(item, selectedProducao) {
      await apiClient.put(`/enquetes/exibicao`, {
        cod_producao: selectedProducao.cod_producao,
        id_enquete: item.id,
      });

      await this.getEnqueteEmExibicao({
        cod_producao: selectedProducao.cod_producao,
      });
      await this.getEnquetes();
    },
    async getEnquetes() {
      const selectedProducao = this.$store.state.producoes.selectedProducao;
      if (!selectedProducao?.cod_producao) {
        console.error("No production selected for getEnquetes");
        return;
      }

      await this.getEnquetesProducao({
        cod_producao: selectedProducao.cod_producao,
        filtro_texto: this.$store.state.enquetes.filtroEnquetes,
        size: 5,
        page: this.aprovadas_current_page,
        cod_portal: this.$store.state.enquetes.selectedPortal,
        id_categoria: this.$store.state.enquetes.selectedCategoria,
      });
    },
    async reloadAllEnquetes() {
      try {
        const selectedProducao = this.$store.state.producoes.selectedProducao;
        if (!selectedProducao || !selectedProducao.cod_producao) {
          console.error("No production selected for reload");
          return;
        }
        const cod_producao = selectedProducao.cod_producao;
        await Promise.all([
          this.getEnquetes(),
          this.getEnqueteEmExibicao({ cod_producao }),
        ]);
      } catch (error) {
        console.error("Error reloading enquetes:", error);
        this.$toast.error("Erro ao recarregar enquetes");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-tab {
  text-transform: none !important;
  color: #171717 !important;
}

.card-item-wrapper {
  margin-bottom: 8px;
}
</style>
